var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tabs',{attrs:{"defaultActiveKey":"1"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"数据看板"}},[_c('index-tab',{attrs:{"type":"active"}})],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"做单数据"}},[_c('post-tab',{attrs:{"type":"active"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }